import { Breakpoint, Breakpoints } from './media-query.types';

export const breakpoints: {
    [key in Breakpoints]: Breakpoint;
} = {
    mobile: {
        size: 320,
        next: 480,
        active: false,
    },
    mobilePlus: {
        size: 480,
        next: 768,
        active: false,
    },
    tabletPortrait: {
        size: 768,
        next: 1024,
        active: false,
    },
    tabletLandscape: {
        size: 1024,
        next: 1260,
        active: false,
    },
    laptop: {
        size: 1260,
        next: 1600,
        active: false,
    },
    desktop: {
        size: 1600,
        active: false,
    },
};
